import {MIGRATED_PORTAL_MODULES} from './migrated-portal-modules'
import {normalizeNavPath} from './normalize-nav-path'

export const PORTAL_MODULE_PREFS_COOKIE_KEY = 'portal_module_prefs'

export type PortalModulePrefs = Record<string, boolean>

export function getDefaultPortalModulePrefs(): PortalModulePrefs {
  return Object.fromEntries(MIGRATED_PORTAL_MODULES.map((module) => [module.id, true]))
}

export function parsePortalModulePrefs(raw: string | undefined | null): PortalModulePrefs {
  const defaults = getDefaultPortalModulePrefs()
  if (!raw) return defaults

  try {
    const parsed = JSON.parse(decodeURIComponent(raw)) as unknown
    if (typeof parsed !== 'object' || parsed == null || Array.isArray(parsed)) return defaults

    const merged = {...defaults}
    for (const module of MIGRATED_PORTAL_MODULES) {
      const value = (parsed as Record<string, unknown>)[module.id]
      if (typeof value === 'boolean') merged[module.id] = value
    }
    return merged
  } catch {
    try {
      const parsed = JSON.parse(raw) as unknown
      if (typeof parsed !== 'object' || parsed == null || Array.isArray(parsed)) return defaults

      const merged = {...defaults}
      for (const module of MIGRATED_PORTAL_MODULES) {
        const value = (parsed as Record<string, unknown>)[module.id]
        if (typeof value === 'boolean') merged[module.id] = value
      }
      return merged
    } catch {
      return defaults
    }
  }
}

export function serializePortalModulePrefs(prefs: PortalModulePrefs): string {
  return JSON.stringify(prefs)
}

export function resolveModuleIdFromPath(path: string): string | null {
  const normalized = normalizeNavPath(path)

  for (const module of MIGRATED_PORTAL_MODULES) {
    if (
      normalized === module.legacyPath ||
      normalized === module.newPath ||
      normalized.startsWith(`${module.legacyPath}/`) ||
      normalized.startsWith(`${module.newPath}/`)
    ) {
      return module.id
    }
  }

  return null
}

export function isModuleNewPortalEnabled(moduleId: string, prefs: PortalModulePrefs = getDefaultPortalModulePrefs()): boolean {
  return prefs[moduleId] ?? true
}

export function isNewPortalEnabledForPath(path: string, prefs: PortalModulePrefs = getDefaultPortalModulePrefs()): boolean {
  const moduleId = resolveModuleIdFromPath(path)
  if (!moduleId) return true

  const module = MIGRATED_PORTAL_MODULES.find((item) => item.id === moduleId)
  if (module && !module.label) return true

  return isModuleNewPortalEnabled(moduleId, prefs)
}
